import axios from "../../config/axiosConfig";
import {
  CREATE_DRAFT_COLLECTION,
  DELETE_DRAFT_COLLECTION,
  GET_DRAFT_COLLECTIONS,
  DRAFT_COLLECTION_REQUEST,
  DRAFT_COLLECTION_REQUEST_SUCCESS,
  DRAFT_COLLECTION_REQUEST_FAILURE,
  UPDATE_DRAFT_COLLECTION,
  GET_DRAFT_COLLECTIONS_PAGE
} from "../types";
import { getStates } from "./state-actions";

export const getDraftCollectionWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal, pendingApproved) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_COLLECTION_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where, pendingApproved: pendingApproved,
        includeAttr: 'Account_Id'
      };
      return axios.get("/draft-collection/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DRAFT_COLLECTIONS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDraftCollections = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_COLLECTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/draft-collection/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DRAFT_COLLECTIONS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDraftCollectionsByRange = (bookId, billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId, billId, from, to
      };
      
      const response = await axios.get("/draft-collection/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDraftCollectionById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_COLLECTION_REQUEST });
      return axios.get(`/draft-collection/get/${id}`).then((response) => {
        dispatch({ type: DRAFT_COLLECTION_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
export const createDraftCollection = (draftCollection) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: DRAFT_COLLECTION_REQUEST });
      const newDraftCollection = {
        ...draftCollection
      };
      return axios.post("/draft-collection/add", newDraftCollection,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_DRAFT_COLLECTION, payload: response.data });
        } else {
          dispatch({
            type: DRAFT_COLLECTION_REQUEST_FAILURE,
            error: "Sales Order create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDraftCollection = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_COLLECTION_REQUEST });
      const { auth } = getState();
      return axios.put("/draft-collection/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DRAFT_COLLECTION,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: DRAFT_COLLECTION_REQUEST_FAILURE,
            error: "Sales Order update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteDraftCollection = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_COLLECTION_REQUEST });
      return axios.delete(`/draft-collection/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_DRAFT_COLLECTION, id: id });
        }
        const include = ['id', 'Date', 'Account_Id', 'Bank', 'Cheque_No', 'Remark', 'Total_Bill_Amount', 'Net_Int_Amt_After_TDS', 'Net_Total', 'Status', 'Collection_User_Id', 'Image_Path'].join(',');
        const searchCols = ['Date', 'Account_Id', 'Bank', 'Cheque_No', 'Remark', 'Total_Bill_Amount', 'Net_Int_Amt_After_TDS', 'Net_Total', 'Status', 'Collection_User_Id'].join(',');
        const { page, pageSize, searchStr, where,  } = getState()?.transaction?.draftCollection || {};
        dispatch(getDraftCollectionWithPagination(page, pageSize, include, searchStr, searchCols, where, true, null));
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_COLLECTION_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDraftCollectionStatus = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      return axios.put("/draft-collection/update-status", { id, data },
        { params: { userId: auth.user?.id } }
      ).then((response) => {
        return response;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};
